import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import PageLoading from './components/shared/PageLoading';
import Axios from 'axios'
import moment from 'moment'

Vue.config.productionTip = false

Vue.component('PageLoading', PageLoading);

Vue.prototype.moment = moment;
moment.locale('pt-BR');

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token');
const user = localStorage.getItem('user');

if (token && user) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token;

  store.dispatch('setToken', token);
  store.dispatch('setUser', JSON.parse(user))
    .then(() => {
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    });
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
